import { ReactElement, useEffect, useState } from "react";
import { DashboardContainer } from "./Dashboard/DashboardCointainer";
import { SideBarContainer } from "./SideBar/SideBarContainer";
import { EquiposContainer } from "./Equipos/EquiposContainer";


export enum MenuItems {
    DASHBOARD = "Dashboard",
    EQUIPOS = "Equipos",
};

export function VendManagementContainer() {
    const [currentSection, setCurrentSection] = useState<MenuItems>(MenuItems.DASHBOARD);
    const [currentComponent, setCurrentComponent] = useState<ReactElement>(); 

    const sectionComponents = {
        Dashboard: <DashboardContainer />,
        Equipos: <EquiposContainer />,
    }

    useEffect(() => {
        console.log(currentSection)
        setCurrentComponent(sectionComponents[currentSection]);
    }, [currentSection]);

    return (
        <div className="flex flexs-col w-full h-full">
            <SideBarContainer 
                currentSelection={currentSection}
                setCurrentSection={setCurrentSection}/>

            <div className="flex flex-col h-full w-full p-2">
                {currentComponent}
            </div>

        </div>
    )
}